import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';
import './AuthLayout.css';

export function AuthLayout() {
    const { isAuthenticated } = useAuthStore();

    // 已登录则跳转到首页
    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <div className="auth-layout">
            <div className="auth-container">
                <div className="auth-logo">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="logo-icon">
                        <circle cx="12" cy="12" r="10" />
                        <circle cx="12" cy="12" r="3" fill="currentColor" stroke="none" />
                    </svg>
                    <span className="logo-text">GitCenter</span>
                </div>
                <div className="auth-card">
                    <Outlet />
                </div>
                <p className="auth-footer">
                    GitCenter - 现代化代码托管平台
                </p>
            </div>
        </div>
    );
}
